import React from 'react'
import { connect } from 'react-redux';
import GoogleAddress from 'components/Lookups/GoogleAddress'
import Select from '../../../commons/Select'
import { residentialHistoryChanged } from '../../../../actions'
import { getResidentialHistory } from '../../../../reducers';
import AddressLookup from 'components/Lookups/Address'

class Address extends React.Component {
  onChange = (params) => {
    let { residentialHistory , residentialHistoryChanged } = this.props;
    residentialHistoryChanged({
      ...{ key: residentialHistory.key },
      ...params
    })
  }

  render() {
    const {
      errors,
      residentialHistory,
      allowDestroy,
    } = this.props

    let years = [{ value: '0', label: '0' }];
    let months = [{ value: '0', label: '0' }];
    for (var i = 1; i < 4; i++) {
      years.push( { value: i, label: i } )
    }
    years.push( { value: '>3', label: '>3' } )

    for (var i = 1; i < 13; i++) {
      months.push( { value: i, label: i } )
    }

    if (residentialHistory._destroy) {
      return(null)
    }

    return (
      <div>
        <div className='row'>
          <div className='col col-sm-10'>
            <div className='form-group'>
              <label>Address</label>
              <AddressLookup
                inputGroupClass='w-100'
                placeholder='Address - e.g. 1 York Street, Sydney, NSW 2000'
                defaultValue={ residentialHistory.location ? residentialHistory.location.fullAddress : '' }
                onChange={ (result) => { this.onChange(result) } }
                errorMessage={ residentialHistory.errors['location.address'] }
              />
              {/*<GoogleAddress*/}
              {/*  defaultValue={ residentialHistory.location ? residentialHistory.location.fullAddress : '' }*/}
              {/*  placeholder='Address - e.g. 1 York Street, Sydney, NSW 2000'*/}
              {/*  errorMessage={ residentialHistory.errors['location.address'] }*/}
              {/*  onChange={ (result) => { this.onChange(result) } }*/}
              {/*/>*/}
            </div>
          </div>
        </div>
        <div className='form-group'>
          <label>How long have you lived at this address?</label>
          <div className='form-row'>
            <div className='col-6 col-sm-2 pb-2'>
              <Select
                defaultValue={ residentialHistory.years || '' }
                onChange={ (year) => { this.onChange({years: year}) } }
                options={years}
              />
            </div>
            <div className='col-3 col-sm-2 align-self-center pb-2'>
              <div className='text-muted'>
                years
              </div>
            </div>
            <div className='col-6 col-sm-2 pb-2'>
              <Select
                defaultValue={ residentialHistory.months || '' }
                onChange={ (month) => { this.onChange({months: month}) } }
                options={months}
              />
            </div>
            <div className='col-3 col-sm-2 align-self-center pb-2'>
              <div className='text-muted'>
                months
              </div>
            </div>
          </div>
          {
            allowDestroy && (
              <div>
                <div
                  className='pointer smaller grey pull-right residential-history-delete'
                  onClick={ () => { this.onChange({'_destroy': 1}) } }
                >
                  Remove
                </div>
              </div>
            )
          }
        </div>
        <hr className="mt-4 mb-4"/>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  residentialHistory: getResidentialHistory(state, ownProps.id)
})

export default connect(mapStateToProps, {
  residentialHistoryChanged
})(Address);
